import { type FC, useEffect, useMemo } from 'react';
import { useFragment, graphql } from 'react-relay';
import { useLoadPhotoLikes } from './hooks/useLoadPhotoLikes.ts';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls.ts';

import { type PhotoLikesMap } from './PhotoLikesContext.tsx';
import { type PhotoLikesLoader_searchResult$key } from './__generated__/PhotoLikesLoader_searchResult.graphql.ts';

export type { PhotoLikesMap };

type Props = {
    searchResult: PhotoLikesLoader_searchResult$key | null | undefined;
    userId: string;
    onLoaded: (_map: PhotoLikesMap) => void;
};

const PhotoLikesLoader: FC<Props> = ({ searchResult: searchResultRef, userId, onLoaded }) => {
    const searchResult = useFragment(
        graphql`
            fragment PhotoLikesLoader_searchResult on TradeInteriorProjectQueryOutput {
                project {
                    tradePhotos {
                        url
                    }
                }
            }
        `,
        searchResultRef
    );

    const photoUrls = useMemo(
        () =>
            (searchResult?.project?.tradePhotos || [])
                .map(tradePhoto => tradePhoto?.url || null)
                .filter(filterNulls),
        [searchResult]
    );

    const photoLikesMap = useLoadPhotoLikes({
        photoUrls,
        userId,
    });

    useEffect(() => {
        if (photoLikesMap) {
            onLoaded(photoLikesMap);
        }
    }, [photoLikesMap, onLoaded]);

    return null;
};

export default PhotoLikesLoader;
